var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluation-form-scoped"
  }, [_c('p', {
    staticStyle: {
      "margin": "15px 0"
    }
  }, [_vm._v("评分参考标准："), _c('router-link', {
    staticClass: "el-button--text",
    attrs: {
      "to": {
        path: '/scoreTips',
        query: {
          scoreType: _vm.scoreType
        }
      },
      "target": "_blank"
    }
  }, [_vm._v("点击查看")])], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "label-width": "200px",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "评分标准",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "score",
    staticClass: "text-content",
    attrs: {
      "placeholder": "请按照参考评分标准，依次填写评分。如：ABBCBDSBD，如有非必考察项请用“-”代替，如：ABBCBD---（根据每轮面试要求定）",
      "maxlength": 9
    },
    on: {
      "focus": function($event) {
        _vm.showScoreTip = true
      },
      "blur": function($event) {
        _vm.showScoreTip = false
      }
    },
    model: {
      value: (_vm.form.score),
      callback: function($$v) {
        _vm.$set(_vm.form, "score", $$v)
      },
      expression: "form.score"
    }
  })], 1), _vm._v(" "), _c('score-tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showScoreTip),
      expression: "showScoreTip"
    }],
    attrs: {
      "type": _vm.scoreType
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价意见",
      "required": ""
    }
  }, [_c('el-radio-group', {
    ref: "userViewpoint",
    model: {
      value: (_vm.form.userViewpoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "userViewpoint", $$v)
      },
      expression: "form.userViewpoint"
    }
  }, _vm._l((_vm.viewPointOptions), function(item, index) {
    return (item.value != '-1') ? _c('el-radio', {
      key: item.value,
      staticClass: "mr-20",
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text))]) : _vm._e()
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.userViewpoint === '3' || _vm.form.userViewpoint === '4'),
      expression: "form.userViewpoint === '3' || form.userViewpoint === '4'"
    }],
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("无须填写薪资相关信息")])], 1), _vm._v(" "), (_vm.advise.length) ? _c('el-form-item', {
    attrs: {
      "label": "岗位建议方向",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    ref: "hireAdvice",
    model: {
      value: (_vm.form.hireAdvice),
      callback: function($$v) {
        _vm.$set(_vm.form, "hireAdvice", $$v)
      },
      expression: "form.hireAdvice"
    }
  }, _vm._l((_vm.advise), function(item, index) {
    return _c('el-checkbox', {
      key: index,
      staticClass: "mr-20",
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.userViewpoint === '3' || _vm.form.userViewpoint === '4'),
      expression: "form.userViewpoint === '3' || form.userViewpoint === '4'"
    }],
    staticClass: "red"
  }, [_vm._v("无须填写薪资相关信息")])], 1) : _vm._e(), _vm._v(" "), (_vm.recruitType === 'social') ? _c('el-form-item', {
    attrs: {
      "label": "建议定级",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "grade",
    staticClass: "text-content",
    attrs: {
      "maxlength": 50,
      "placeholder": "主属性中5项B级以上建议初一，游戏/软件/兼容性测试对应的关键主属性有3项A级以上参考初二，有1项S其他A参考中一"
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.recruitType === 'social') ? _c('el-form-item', {
    staticClass: "inner-row",
    attrs: {
      "label": "当前薪资",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-row', [_c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("月基本薪资")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthBaseSalary",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "建议注明 税前/税后",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthBaseSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthBaseSalary", $$v)
      },
      expression: "form.monthBaseSalary"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("薪资一年发放月份")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "monthCount",
    staticClass: "text-content",
    attrs: {
      "maxlength": 20,
      "placeholder": "填写实际月份数即可，如一年薪资发放13个月则填写：13",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.monthCount),
      callback: function($$v) {
        _vm.$set(_vm.form, "monthCount", $$v)
      },
      expression: "form.monthCount"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "inner-td",
    attrs: {
      "span": 4
    }
  }, [_vm._v("其他福利说明")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-input', {
    ref: "otherWelfare",
    staticClass: "text-content",
    attrs: {
      "maxlength": 100,
      "placeholder": "如：包三餐、包住宿、每月项目奖金、其他奖金等",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.otherWelfare),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherWelfare", $$v)
      },
      expression: "form.otherWelfare"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "期望描述",
      "required": _vm.form.userViewpoint !== '3' && _vm.form.userViewpoint !== '4'
    }
  }, [_c('el-input', {
    ref: "expectSalary",
    staticClass: "text-content",
    attrs: {
      "maxlength": 100,
      "placeholder": "根据候选人实际要求填写即可，请尽可能详细；如年薪XX万、月薪6k*13"
    },
    model: {
      value: (_vm.form.expectSalary),
      callback: function($$v) {
        _vm.$set(_vm.form, "expectSalary", $$v)
      },
      expression: "form.expectSalary"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试记录",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "interviewRecord",
    staticClass: "text-content",
    attrs: {
      "maxlength": 8000,
      "placeholder": "请输入面试问答详情",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.interviewRecord),
      callback: function($$v) {
        _vm.$set(_vm.form, "interviewRecord", $$v)
      },
      expression: "form.interviewRecord"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "综合评价",
      "required": ""
    }
  }, [_c('el-input', {
    ref: "content",
    staticClass: "text-content",
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "maxlength": 2000,
      "placeholder": "请输入评价内容",
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1), _vm._v(" "), (false) ? _c('society-form-tips', {
    attrs: {
      "isSociety": this.recruitType !== 'campus'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("提交评估")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca340560"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form-more.vue
// module id = null
// module chunks = 